module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_gaseosas_pet_500_ccsa.8ca59e5d.png";